import { AxiosPromise }                 from "axios";
import Date                             from "../../../domain/fundamentals/date/Date";
import Time                             from "../../../domain/fundamentals/date/Time";
import ReservationBusinessDayType       from "../../../domain/reservation/ReservationBusinessDayType";
import ReservationSetting               from "../../../domain/reservation/ReservationSetting";
import { ReservationSettingRepository } from "../../../domain/reservation/ReservationSettingRepository";
import ReservationSpecialBusinessTime   from "../../../domain/reservation/ReservationSpecialBusinessTime";
import ReservationTimeType              from "../../../domain/reservation/ReservationTimeType";
import ReservationWeekType              from "../../../domain/reservation/ReservationWeekType";
import { ApiClient }                    from "../../configure/ApiClientConfig";
import {
  addSpecialBusinessTime,
  onChangeBusinessDayType,
  onChangeBusinessTimeFrom,
  onChangeBusinessTimeTo,
  onChangeBusinessTimeType,
  onChangeSpecialBusinessDate,
  onChangeSpecialBusinessDayType,
  onChangeSpecialBusinessTimeFrom,
  onChangeSpecialBusinessTimeTo,
  setReservationSettingAction, specialBusinessTimeDelete
} from "../../redux/reservation/ReservationSettingAction";

export default class ReservationSettingDataSource implements ReservationSettingRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  get(): AxiosPromise<any> {
    return ApiClient.get("/reservation/setting");
  }

  save(reservationSetting: ReservationSetting): AxiosPromise<any> {
    return ApiClient.put("/reservation/setting", {
      displayTimeType: reservationSetting.timeType.value,
      businessTimes: reservationSetting.businessTimes.toList().map(businessTime => ({
        weekType: businessTime.weekType.value,
        regularHoliday: businessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY,
        from: businessTime.from.asText(),
        to: businessTime.to.asText()
      })),
      specialBusinessTimes: reservationSetting.specialBusinessTimes.toList().map(specialBusinessTime => ({
        holiday: specialBusinessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY,
        date: specialBusinessTime.date.asISOText(),
        from: specialBusinessTime.from.asText(),
        to: specialBusinessTime.to.asText()
      }))
    })
  }

  deleteSpecialBusinessTime(index: number, date: Date): AxiosPromise<any> {
    this.dispatch(specialBusinessTimeDelete(index));
    return ApiClient.delete("/reservation/setting/specialBusinessTime", {
      params: {
        date: date.asISOText()
      }
    })
  }

  store(reservationSetting: ReservationSetting): void {
    this.dispatch(setReservationSettingAction(reservationSetting));
  }

  onChangeBusinessTimeFrom(weekType: ReservationWeekType, from: Time): void {
    this.dispatch(onChangeBusinessTimeFrom(weekType, from));
  }

  onChangeBusinessTimeTo(weekType: ReservationWeekType, to: Time): void {
    this.dispatch(onChangeBusinessTimeTo(weekType, to));
  }

  onChangeTimeType(timeType: ReservationTimeType): void {
    this.dispatch(onChangeBusinessTimeType(timeType));
  }

  onChangeBusinessDayType(weekType: ReservationWeekType, dayType: ReservationBusinessDayType): void {
    this.dispatch(onChangeBusinessDayType(weekType, dayType));
  }

  onChangeSpecialBusinessDate(index: number, date: Date): void {
    this.dispatch(onChangeSpecialBusinessDate(index, date));
  }

  onChangeSpecialBusinessDayType(index: number, dayType: ReservationBusinessDayType): void {
    this.dispatch(onChangeSpecialBusinessDayType(index, dayType));
  }

  onChangeSpecialBusinessTimeFrom(index: number, from: Time): void {
    this.dispatch(onChangeSpecialBusinessTimeFrom(index, from));
  }

  onChangeSpecialBusinessTimeTo(index: number, to: Time): void {
    this.dispatch(onChangeSpecialBusinessTimeTo(index, to));
  }

  addSpecialBusinessTime(specialBusinessTimes: ReservationSpecialBusinessTime): void {
    this.dispatch(addSpecialBusinessTime(specialBusinessTimes));
  }

}